export default {
  gb_en: {
    navbar: {
      logo: 'logo_je.svg',
      link: 'https://www.just-eat.co.uk',
      language: 'Country',
      name: 'Just Eat',
      country_toggle: [
        {
          logo: 'gb',
          url: 'https://couriers.just-eat.co.uk/application',
          text: 'Great Britain'
        },
        {
          logo: 'au',
          url: 'https://couriers.menulog.com.au/application',
          text: 'Australia'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application',
          text: 'Canada'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application/fr',
          text: 'Canada - FR'
        },
        {
          logo: 'ie',
          url: 'https://couriers.just-eat.ie/application',
          text: 'Ireland'
        },
      ],
      menu: [
        {
          text: 'Home',
          url: 'https://couriers.just-eat.co.uk/application',
          target: '_self'
        },
        {
          text: 'FAQs',
          url: 'https://couriers.just-eat.co.uk/application#faqs',
          target: "_self"
        },
        {
          text: 'The Inside Track',
          url: 'https://insidetrack.just-eat.co.uk',
          target: '_blank',
        },
      ],
      menuButton: {
        text: 'Apply now',
        url: 'https://couriers.just-eat.co.uk/signup'
,     },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Fast cash,<br>flexible work',
      sub: 'Make extra money fast and fit<br>delivering around your lifestyle.',
      buttonText: 'Apply now',
      buttonUrl: 'https://couriers.just-eat.co.uk/signup',
      image: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/Courier.webp'
    },
    benefits: {
      title: 'Why deliver with Just Eat?',
      cards: [
        {
          name: 'Flexible hours',
          color: 'red',
          image: 'flexible.webp',
          text: 'Work when you want. Choose your own schedule and submit your run requests each week.',
          hiddenMobile: false,
        },
        {
          name: 'Weekly pay',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'With weekly deposits direct to your bank account, you’ll get fast access to your cash.',
          hiddenMobile: true,
        },
        {
          name: 'Keep 100% of tips',
          color: 'purple',
          image: 'bag.svg',
          text: 'Earners, keepers. Whatever tips you make, you’ll pocket the full amount.',
          hiddenMobile: false,
        },
        {
          name: 'Be part of a community',
          color: 'pink',
          image: 'pins.svg',
          text: 'Join our community of couriers delivering throughout the U.K.',
          hiddenMobile: false,
        },
        {
          name: 'Round-the-clock support',
          color: 'orange',
          image: 'support.svg',
          text: 'Whether you need advice or support, simply chat with us via the courier app.',
          hiddenMobile: false,
        },
        {
          name: 'No experience needed',
          color: 'blue',
          image: 'curior.svg',
          text: 'Just making your first career move? We welcome new starters with no previous delivery experience.',
          hiddenMobile: true,
        },
      ]
    },
    requirements: {
      image: 'iPhone-uk.webp',
      title: "What you'll need?",
      list: [
        {
          text: 'Age 18+',
        },
        {
          text: 'Smartphone - iOS or Android',
        },
        {
          text: 'A moped, bike or car - plus licence and the correct insurance',
        },
      ],
      tips: 'Tips to speed up your application',
      moreInfo: [
        {
          title: 'Grab these',
          list: [
            {
              text: 'Government-issued photo ID.'
            },
            {
              text: 'Details of your food delivery insurance.',
            },
            {
              text: 'Proof of work eligibility.'
            }
          ],
        },
        {
          title: 'Important',
          list: [
            {
              text: 'Enter your full name on your courier, and Sterling application, as per your government ID.',
            },
            {
              text: 'Unfortunately, we are unable to accept your application if you have a criminal record.',
            },
            {
              text: 'Refrain from creating duplicate accounts - doing so will result in your application being cancelled.'
            },
            {
              text: 'By signing up to provide delivery services, you acknowledge your status as an independent contractor, assuming responsibility for your own tax returns and any expenses related to substitutes.',
            }
          ]
        },
        {
          title: 'Background check with <img src="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/sterling.webp" alt=""> <span>Sterling</span>',
          list: [
            {
              text: 'Sterling run our background screening checks, look out for their email - this may end up in your spam folder.',
            },
            {
              text: "If you’re using your own check, ensure it's dated within the last 90 days."
            }
          ]
        }
      ],
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.just-eat.co.uk/signup'
    },
    diaries: {
      title: 'Just Eat Meets',
      videos: [
        {
          id: 'https://www.youtube.com/embed/GrPtXFOA3xQ?si=OfRD5Wl7vyWLa9uT',
        },
      ]
    },
    commonVideos: {
      title: 'Common questions',
      videos: [
        {
          title: 'What documents do I need?',
          image: 'courier-happy.webp',
          id: 'WjQmenvnK4Q',
        },
        {
          title: 'How flexible is delivering?',
          image: 'courier-bike.webp',
          id: 'vqcm7T1F7vQ',
        },
        {
          title: 'How do I book delivery runs?',
          image: 'courier-group.webp',
          id: '_xqPnPR7mpM',
        },
        {
          title: 'Completing your background check',
          image: 'courier-car-uk.webp',
          id: 'E3EKUr7d-KA',
        }
      ]
    },
    faqs: {
      title: 'More questions?',
      questionsLeft: [
        {
          question: 'What are the requirements to deliver with Just Eat?',
          answer: `
          <p>To deliver with us, you’ll need:</p>
          <ul>
            <li>To be aged +18.</li>
            <li>An Apple or Android smartphone with data.</li>
            <li>A moped, bike or car - plus licence and the correct insurance</li>
            <li>A bank account, so you can receive your money.</li>
          </ul>
          <p>When signing up, we may also ask for the following:</p>
          <ul>
            <li>A copy of your passport.</li>
            <li>Proof of your right to work in the UK.</li>
          </ul>
          <p>To deliver with us, you’ll need to undergo a background and right to work check with our partner, Sterling (keep a lookout for an email from them). If you already have a background check dated within the last 90 days, we may be able to use this, we’ll let you know when and how to share this with us.</p>
          <p>Drop it like it’s hot? You’ll also need a food delivery bag – but don’t worry, we can help you with that.</p>
          <p>Remember, you choose when, and how often, you deliver – the power is in your hands. Let's go!</p>
          `
        },
        {
          question: 'How do I make money?',
          answer: `
          <p>Delivering with Just Eat means you will make money for each delivery. The courier app will send you delivery ‘offers’. You can review each of these offers and decide if you’d like to complete the delivery.</p>
                <p>The fee up for grabs for each offer varies and you’ll be shown details of this in app before accepting the offer.</p>
                <p>We pay the money you’ve made directly into your chosen bank account every week.</p>
                <p>We love providing great service to our couriers, customers and partners. You have the opportunity to earn tips and you keep 100% of these. Any tips received from customers will appear in your weekly <a href="http://couriers.just-eat.co.uk/linking/Earnings" target="_blank">statement</a>.</p>
                `
        },
        {
          question: 'Do I need to submit my availability every week?',
          answer: `
          <p>Across most of the U.K, we operate a closed network. This is to help ensure a balanced match between the number of available couriers and the anticipated volume of orders. This means we can try avoid scenarios where an excess of couriers are online with insufficient orders to go around - it’s our way of trying to ensure everybody is kept busy and making money.</p>
                <p>Submitting your availability is easy. Clicking <a href="https://couriers.just-eat.co.uk/linking/Availability" target="_blank">here</a> will take you directly to the scheduling section in the courier app. Simply submit when you’d  like to deliver by midnight every Wednesday and the following day, we’ll email your schedule as well as updating the <a href="http://couriers.just-eat.co.uk/linking/MyShifts" target="_blank">My Schedule</a> page in app.</p>
                <p>When things are busy, you might have the opportunity to spontaneously begin delivering by accessing the app without a booked run, referred to as open runs - you can see open runs in your zone <a href="http://couriers.just-eat.co.uk/linking/OpenShifts" target="_blank">here</a>. The availability of open runs is not guaranteed so we recommend you submit your availability each week.</p>
                `
        }
      ],
      questionsRight: [
        {
          question: 'Background check',
          answer: `
          <p>Safety is always our priority. Everybody who delivers is required to share an existing, or complete a new, criminal background and right to work (RTW) check. Completing a new check takes about 15 minutes.</p>
                <p>For new checks, you’ll receive an email from a company called Sterling. Sterling run our background screening, so keep an eye on your inbox (and spam folder) for an email from noreply@sterling.app. When logging into the Sterling platform, it’s crucial you use the same email address used in your courier sign-up and your full name as per your government ID.</p>
                <p>When you’ve received your email from Sterling, you’ll need some important documents. Make sure to get these ready before the check and you’ll be done in no time.</p>
                <ul>
                  <li>Address history for the past 5 years</li>
                  <li>Proof of address within the past 3 months (e.g., a utility bill or bank statement)</li>
                  <li>Place of birth and nationality</li>
                  <li>Passport</li>
                  <li>Driving licence</li>
                  <li>NI number</li>
                  <li>UK Right to Work share code</li>
                </ul>
                <p>If you’re a non-UK National, please have your Biometric Residence Permit handy.</p>
                <p>Once you’ve completed your check, it’s automatically sent to us and we’ll be in touch. If you have any questions once you’ve submitted your check, please <a href="mailto:gigcandidatesupport@sterlingcheck.com" target="_blank">email Sterling</a> directly.</p>
          `,
        },
        {
          question: 'Can I use my own equipment?',
          answer: `
          <p>There's no obligation to use Just Eat-branded equipment. Feel free to use your own equipment however, you must ensure that it meets our minimum safety requirements.</p>
                <p>If you have your own commercial-grade food delivery bag(s), you’ll be able to share details with us for approval during the sign-up process.</p>`
        },
        {
          question: 'My preferred delivery zone is closed so I applied in a different one. Can I change to my preferred zone?',
          answer: `
          <p>Please only apply in the zone you wish to deliver in. If your preferred zone is closed, we’re not able to transfer your account.</p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_je.svg',
      link: 'https://www.just-eat.co.uk',
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.just-eat.co.uk/signup',
    },
    gtm: {
      trackingID: 'GTM-TMPX9FN',
      countryPlatform: 'uk',
      platform_language: 'en'
    },
    canonical: {
      lang: 'en',
      canonical: 'https://couriers.just-eat.co.uk/application',
      alt: [
        {
          lang: 'en-gb',
          url: 'https://couriers.just-eat.co.uk/application',
        },
      ]
    }
  },
  ie_ie: {
    navbar: {
      logo: 'logo_je.svg',
      link: 'https://www.just-eat.ie',
      language: 'Country',
      name: 'Just Eat',
      country_toggle: [
        {
          logo: 'ie',
          url: 'https://couriers.just-eat.ie/application',
          text: 'Ireland'
        },
        {
          logo: 'au',
          url: 'https://couriers.menulog.com.au/application',
          text: 'Australia'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application',
          text: 'Canada'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application/fr',
          text: 'Canada - FR'
        },
        {
          logo: 'gb',
          url: 'https://couriers.just-eat.co.uk/application',
          text: 'Great Britain'
        },
      ],
      menu: [
        {
          text: 'Home',
          url: '/',
          target: '_self'
        },
        {
          text: 'FAQs',
          url: 'https://couriers.just-eat.ie/application#faqs',
          target: '_self'
        },
        {
          text: 'The Inside Track',
          url: 'https://insidetrack.just-eat.ie',
          target: '_blank',
        },
      ],
      menuButton: {
        text: 'Apply now',
        url: 'https://couriers.just-eat.ie/signup'
,     },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Fast cash,<br>flexible work',
      sub: 'Make extra money fast and fit<br>delivering around your lifestyle.',
      buttonText: 'Apply now',
      buttonUrl: 'https://couriers.just-eat.ie/signup',
      image: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/Courier.webp'
    },
    benefits: {
      title: 'Why deliver with Just Eat?',
      cards: [
        {
          name: 'Flexibility',
          color: 'red',
          image: 'flexible.webp',
          text: 'Freedom to deliver when you want. Choose your schedule and submit run requests each week.',
          hiddenMobile: false,
        },
        {
          name: 'Weekly pay',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'With weekly deposits direct to your bank account, you’ll get fast access to your cash.',
          hiddenMobile: false,
        },
        {
          name: 'Round-the-clock support',
          color: 'orange',
          image: 'support.svg',
          text: 'Whether you need advice or support, simply chat with us via the courier app.',
          hiddenMobile: false,
        },
        {
          name: 'No experience needed',
          color: 'blue',
          image: 'curior.svg',
          text: 'Making your first move? We welcome new starters with no previous experience.',
          hiddenMobile: false,
        },
      ]
    },
    requirements: {
      image: 'iPhone-ie.webp',
      title: "What you'll need?",
      list: [
        {
          text: 'Age 18+ ID',
        },
        {
          text: 'Smartphone - iOS or Android',
        },
        {
          text: 'A moped, bike or car - plus licence and the correct insurance',
        },
      ],
      tips: 'Tips to speed up your application',
      moreInfo: [
        {
          title: 'Grab these',
          list: [
            {
              text: 'Government-issued photo ID.'
            },
            {
              text: 'Details of your food delivery insurance.',
            },
          ],
        },
        {
          title: 'Important',
          list: [
            {
              text: 'Please enter your full name on your courier application, as per your government ID. These details must match exactly.',
            },
            {
              text: 'By signing up to provide your delivery services on the Just Eat network, you acknowledge you are an independent contractor and are responsible for completing your own tax returns. You are also responsible for paying for any substitute you may use.',
            },
            {
              text: 'Finally, please don’t create duplicate accounts - doing so will result in your application being cancelled.',
            },
          ]
        },
        {
          title: 'DAC7',
          list: [
            {
              text: 'Please respond quickly to the DAC7 email received after registration.',
            },
          ]
        }
      ],
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.just-eat.ie/signup'
    },
    diaries: {
      title: 'Just Eat Meets',
      videos: [
        {
          id: 'https://www.youtube.com/embed/GrPtXFOA3xQ?si=OfRD5Wl7vyWLa9uT',
        },
      ]
    },
    commonVideos: {
      title: 'Common questions',
      videos: [
        {
          title: 'What documents do I need?',
          image: 'courier-happy.webp',
          id: 'Q9BdPUd0TFg',
        },
        {
          title: 'How flexible is delivering?',
          image: 'courier-bike.webp',
          id: 'vqcm7T1F7vQ',
        },
        {
          title: 'How do I book delivery runs?',
          image: 'courier-group.webp',
          id: '_xqPnPR7mpM',
        },
      ]
    },
    faqs: {
      title: 'More questions?',
      questionsLeft: [
        {
          question: 'What are the requirements to deliver with Just Eat?',
          answer: `
          <p>To deliver with us, you’ll need:</p>
                <ul>
                  <li>To be aged +18.</li>
                  <li>An Apple or Android smartphone with data.</li>
                  <li>A moped, bike or car - plus licence and the correct insurance</li>
                  <li>A bank account, so you can receive your money.</li>
                </ul>
                <p>When signing up, we may also ask for the following:</p>
                <ul>
                  <li>A copy of your passport.</li>
                  <li>Proof of your right to work.</li>
                </ul>
                <p>Drop it like it’s hot. You’ll also need a food delivery bag – but don’t worry, we can help you with that.</p>
                <p>Remember, you choose when, and how often, you deliver – the power is in your hands. Let's go!</p>
          `
        },
        {
          question: 'How do I make money?',
          answer: `
          <p>Delivering with Just Eat means you’ll make money for each delivery. The courier app will send you delivery ‘offers,’ which you can then review and decide if you’d like to complete the delivery.</p>
                <p>The fee up for grabs for each offer varies and you’ll be shown details of this in app before accepting the offer.</p>
                <p>We pay the money you’ve made directly into your chosen bank account every week.</p>`
        },
        {
          question: 'Do I need to submit my availability every week?',
          answer: `
          <p>We mainly operate a closed network. This is to help make sure  we maintain a balanced match between the number of available couriers and the anticipated volume of orders. This means we can try to avoid scenarios where an excess of couriers are online with insufficient orders to go around. It’s our way of trying to keep  everybody busy and making money.</p>
                <p>Submitting your availability is easy. Clicking <a href="http://couriers.just-eat.ie/linking/Availabiity" target="_blank">here</a> will take you directly to the scheduling section in the courier app. Simply submit when you’d like to deliver by midnight every Wednesday, and the following day, we’ll email your schedule as well as update the <a href="http://couriers.just-eat.ie/linking/MyShifts" target="_blank">My Schedule</a> page in app.</p>
                <p>When things are busy, you might have the opportunity to spontaneously begin delivering by accessing the app without a booked run, referred to as “open runs.” The availability of open runs is not guaranteed so we recommend you submit your availability each week.</p>
          `
        }
      ],
      questionsRight: [
        {
          question: 'Can I use my own equipment?',
          answer: `
          <p>There's no obligation to use Just Eat-branded equipment. Feel free to use your own equipment however, you must ensure that it meets our minimum safety requirements.</p>
          <p>If you have your own commercial-grade food delivery bag(s), you’ll be able to share details with us for approval during the sign-up process.</p>`
        },
        {
          question: 'My preferred delivery zone is closed so I applied in a different one. Can I change to my preferred zone?',
          answer: `
          <p>Please only apply in the zone you wish to deliver in. If your preferred zone is closed, we’re not able to transfer your account.</p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_je.svg',
      link: 'https://www.just-eat.ie',
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.just-eat.ie/signup',
    },
    gtm: {
      trackingID: 'GTM-PRGNM82',
      countryPlatform: 'ie',
      platform_language: 'en'
    },
    canonical: {
      lang: 'en',
      canonical: 'https://couriers.just-eat.ie/application',
      alt: [
        {
          lang: 'en-ie',
          url: 'https://couriers.just-eat.ie/application',
        },
      ]
    }
  },
  ca_en: {
    navbar: {
      logo: 'logo_skip.svg',
      link: 'https://www.skipthedishes.com/',
      language: 'Country',
      name: 'Skip the Dishes',
      country_toggle: [
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application',
          text: 'Canada'
        },
        {
          logo: 'au',
          url: 'https://couriers.menulog.com.au/application',
          text: 'Australia'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application/fr',
          text: 'Canada - FR'
        },
        {
          logo: 'ie',
          url: 'https://couriers.just-eat.ie/application',
          text: 'Ireland'
        },
        {
          logo: 'gb',
          url: 'https://couriers.just-eat.co.uk/application',
          text: 'Great Britain'
        },
      ],
      menu: [
        {
          text: 'Home',
          url: 'https://couriers.skipthedishes.com/application',
          target: '_self',
        },
        {
          text: 'FAQs',
          url: 'https://couriers.skipthedishes.com/application#faqs',
          target: '_self',
        },
        {
          text: 'The Inside Track',
          url: 'https://insidetrack.skipthedishes.com',
          target: '_blank',
        },
      ],
      menuButton: {
        text: 'Apply now',
        url: 'https://couriers.skipthedishes.com/signup'
      },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Fast cash,<br>flexible work',
      sub: 'Make extra money fast and fit<br>delivering around your lifestyle.',
      buttonText: 'Apply now',
      buttonUrl: 'https://couriers.skipthedishes.com/signup',
      image: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/canada-hero.webp'
    },
    benefits: {
      title: 'Why deliver with Skip?',
      cards: [
        {
          name: 'Flexibility',
          color: 'red',
          image: 'flexible.webp',
          text: 'Freedom to deliver when you want. Choose your schedule and submit run requests each week.',
          hiddenMobile: false,
        },
        {
          name: 'Instant pay',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'Get paid after each delivery run, or via weekly deposits direct to your bank account.',
          hiddenMobile: true,
        },
        {
          name: 'Keep 100% of tips',
          color: 'purple',
          image: 'bag.svg',
          text: 'Earners, keepers. Whatever tips you make, you’ll pocket the full amount.',
          hiddenMobile: false,
        },
        {
          name: 'Be part of a community',
          color: 'pink',
          image: 'pins.svg',
          text: 'Join our community of couriers delivering throughout Canada.',
          hiddenMobile: false,
        },
        {
          name: 'Round-the-clock support',
          color: 'orange',
          image: 'support.svg',
          text: 'Whether you need advice or support, simply chat with us via the courier app.',
          hiddenMobile: false,
        },
        {
          name: 'No experience needed',
          color: 'blue',
          image: 'curior.svg',
          text: 'Making your first move? We welcome new starters with no previous experience.',
          hiddenMobile: true,
        },
      ]
    },
    requirements: {
      image: 'iPhone-CA-EN.webp',
      title: "What you'll need?",
      list: [
        {
          text: 'Age 18+ ID',
        },
        {
          text: 'Smartphone - iOS or Android',
        },
        {
          text: 'Car with valid insurance',
        },
      ],
      tips: 'Tips to speed up your application',
      moreInfo: [
        {
          title: 'Grab these',
          list: [
            {
              text: 'Government-issued photo ID.'
            },
            {
              text: 'POWE (Proof of Work Eligibility). We accept Birth Certificates, Passports, or your Work or Study permit.',
            },
          ],
        },
        {
          title: 'Important',
          list: [
            {
              text: 'Please enter your full name on your courier application, as per your government ID. These details must match exactly.',
            },
            {
              text: 'Please don’t create duplicate accounts - doing so will result in your application being cancelled.',
            },
          ]
        },
        {
          title: 'Background check with <img src="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/sterling.webp" alt=""> <span>Sterling</span>',
          list: [
            {
              text: 'Sterling run our background screening checks, look out for their email - this may end up in your spam folder.',
            },
            {
              text: "If you’re using your own check, ensure it's dated within the last 90 days."
            }
          ],                                                      
        }
      ],
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.skipthedishes.com/signup'
    },
    diaries: {
      title: 'Skip Meets',
      videos: [
        {
          id: 'https://www.youtube.com/embed/4hCnhCMCA-I?si=5M2xE57tudiTTdLG',
        },
      ]
    },
    commonVideos: {
      title: 'Common questions',
      videos: [
        {
          title: 'What documents do I need?',
          image: 'courier-happy.webp',
          id: 'KXbUgmm9fFg',
        },
        {
          title: 'How flexible is delivering?',
          image: 'courier-bike.webp',
          id: 'qdpg0jRiHLY',
        },
        {
          title: 'How do I book delivery runs?',
          image: 'courier-group.webp',
          id: 'bBUw-IfLXbc',
        },
        {
          title: 'Completing your background check',
          image: 'courier-documents.webp',
          id: 'Q79FfqLggyM',
        }
      ],
      terms: 'This content was created using professional actors who have been compensated for their participation',
    },
    faqs: {
      title: 'More questions?',
      questionsLeft: [
        {
          question: 'What are the requirements to deliver with Skip?',
          answer: `
          <p>To deliver with us, you’ll need:</p>
                <ul>
                  <li>To be aged +18.</li>
                  <li>An Apple or Android smartphone with data.</li>
                  <li>A bike or insured car</li>
                  <li>A bank account, so you can receive your money.</li>
                </ul>
                <p>When signing up, we may also ask for the following:</p>
                <ul>
                  <li>A copy of your passport.</li>
                  <li>POWE (Proof of Work Eligibility). We accept Birth Certificates, Passports, Certificate of Indian Status, or your Work or Study permit</li>
                </ul>
                <p>Drop it like it’s hot? You’ll also need a food delivery bag – but don’t worry, we can help you with that.</p>
                <p>Remember, you choose when, and how often, you deliver – the power is in your hands. Let's go!</p>
          `
        },
        {
          question: 'How do I make money?',
          answer: `
          <p>Delivering with Skip means you’ll make money for each delivery. The courier app will send you delivery ‘offers,’ which you can then review and decide if you’d like to complete the delivery.</p>
          <p>The fee up for grabs for each offer varies and you’ll be shown details of this in the app before accepting the offer.</p>
          <p>We pay the money you’ve made directly into your chosen bank account every week.</p>`
        },
        {
          question: 'Do I need to submit my availability every week?',
          answer: `
          <p>We mainly operate a closed network. This is to help make sure  we maintain a balanced match between the number of available couriers and the anticipated volume of orders. This means we can try to avoid scenarios where an excess of couriers are online with insufficient orders to go around. It’s our way of trying to keep  everybody busy and making money.</p>
          <p>Submitting your availability is easy. Clicking <a href="http://couriers.skipthedishes.com/linking/Availability" target="_blank">here</a> will take you directly to the scheduling section in the courier app. Simply submit when you’d like to deliver by midnight every Wednesday and, the following day, we’ll email your schedule as well as update the <a href="http://couriers.skipthedishes.com/linking/MyShifts" target="_blank">My Schedule</a> page in app.</p>
          <p>When things are busy, you might have the opportunity to spontaneously begin delivering by accessing the app without a booked run, referred to as “open runs.” The availability of open runs is not guaranteed so we recommend you submit your availability each week.</p>`
        }
      ],
      questionsRight: [
        {
          question: 'Can I use my own thermal bag?',
          answer: `
          <p>There's no obligation to use Skip-branded equipment. Feel free to use your own equipment, however, you must ensure that it meets our minimum safety requirements.</p>
          <p>If you have your own commercial-grade food delivery bag(s), you’ll be able to share details with us for approval during the sign-up process.</p>`
        },
        {
          question: 'My preferred delivery zone is closed so I applied in a different one. Can I change to my preferred zone?',
          answer: `<p>Please only apply in the zone you wish to deliver in. If your preferred zone is closed, we’re not able to transfer your account.</p>`
        },
        {
          question: 'How does instant payment work?',
          answer: `
          <p>Fast Cash allows you to cash out your delivery revenue instantly to a supported debit card, for a fee of $1.99. You may cash out as frequently as you like including weekends and holidays. Fast Cash deposits typically appear in your account within 30 minutes, depending on your bank’s processing time.</p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_skip.svg',
      link: 'https://www.skipthedishes.com/',
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.skipthedishes.com/signup',
    },
    gtm: {
      trackingID: 'GTM-PRGNM82',
      countryPlatform: 'ca',
      platform_language: 'en'
    },
    canonical: {
      lang: 'en',
      canonical: 'https://couriers.skipthedishes.com/application',
      alt: [
        {
          lang: 'en-ca',
          url: 'https://couriers.skipthedishes.com/application',
        },
        {
          lang: 'fr-ca',
          url: 'https://couriers.skipthedishes.com/application/fr'
        }
      ]
    }
  },
  ca_fr: {
    navbar: {
      logo: 'logo_skip.svg',
      link: 'https://www.skipthedishes.com/fr',
      language: 'Pays',
      name: 'Skip the Dishes',
      country_toggle: [
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application/fr',
          text: 'Canada - FR'
        },
        {
          logo: 'au',
          url: 'https://couriers.menulog.com.au/application',
          text: 'Australia'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application',
          text: 'Canada'
        },
        {
          logo: 'ie',
          url: 'https://couriers.just-eat.ie/application',
          text: 'Ireland'
        },
        {
          logo: 'gb',
          url: 'https://couriers.just-eat.co.uk/application',
          text: 'Great Britain'
        },
      ],
      menu: [
        {
          text: 'Home',
          url: 'https://couriers.skipthedishes.com/application',
          target: '_self',
        },
        {
          text: 'FAQ',
          url: 'https://couriers.skipthedishes.com/application#faqs',
          target: '_self',
        },
        {
          text: 'Sur la route',
          url: 'https://surlaroute.skipthedishes.com',
          target: '_blank',
        },
      ],
      menuButton: {
        text: 'Inscrivez-vous',
        url: 'https://couriers.skipthedishes.com/signup'
,     },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Argent rapide,<br>horaire flexible',
      sub: 'Gagnez un revenu supplémentaire rapidement et livrez selon votre style de vie',
      buttonText: 'Inscrivez-vous',
      buttonUrl: 'https://couriers.skipthedishes.com/signup',
      image: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/canada-hero.webp'
    },
    benefits: {
      title: 'Pourquoi livrer avec Skip?',
      cards: [
        {
          name: 'Flexibilité',
          color: 'red',
          image: 'flexible.webp',
          text: 'La liberté de livrer quand vous voulez. Fixez vos disponibilités et demandez des parcours chaque semaine.',
          hiddenMobile: false,
        },
        {
          name: 'Paiement instantané',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'Recevez votre argent après chaque parcours ou par dépôt direct dans votre compte bancaire toutes les semaines.',
          hiddenMobile: false,
        },
        {
          name: '100 % des pourboires',
          color: 'purple',
          image: 'bag.svg',
          text: 'Vous les gagnez, vous les gardez. Peu importe les pourboires que vous recevrez, vous empocherez la totalité.',
          hiddenMobile: true,
        },
        {
          name: 'Appartenance à une communauté',
          color: 'pink',
          image: 'pins.svg',
          text: 'Joignez-vous à une communauté dynamique de coursières et coursiers livrant au Canada.',
          hiddenMobile: true,
        },
        {
          name: 'Soutien en tout temps',
          color: 'orange',
          image: 'support.svg',
          text: 'Nous sommes toujours là pour vous aider. Que vous ayez besoin de conseils ou de soutien, il suffit de clavarder avec nous dans l’appli.',
          hiddenMobile: false,
        },
        {
          name: 'Aucune expérience requise',
          color: 'blue',
          image: 'curior.svg',
          text: 'C’est la première fois que vous livrez? Nous accueillons tout le monde, même si vous n’avez pas d’expérience.',
          hiddenMobile: true,
        },
      ]
    },
    requirements: {
      image: 'iPhone-CA-FR.webp',
      title: "Ce dont vous aurez besoin",
      list: [
        {
          text: 'Une pièce d’identité prouvant que vous avez 18 ans ou plus',
        },
        {
          text: 'Un téléphone intelligent – iOS ou Android',
        },
        {
          text: 'Un vélo ou un véhicule assuré',
        },
      ],
      tips: 'Conseils pour accélérer votre inscription',
      moreInfo: [
        {
          title: 'Ayez en main ce qui suit',
          list: [
            {
              text: 'Une pièce d’identité avec photo émise par le gouvernement.'
            },
            {
              text: 'Une preuve d’autorisation de travail : certificat de naissance, passeport, permis de travail ou d’études.',
            },
          ],
        },
        {
          title: 'Important',
          list: [
            {
              text: 'Veuillez inscrire votre nom complet sur votre demande d’inscription, comme il apparaît sur votre pièce d’identité émise par le gouvernement. Ces renseignements doivent être identiques.',
            },
            {
              text: 'Ne créez pas de comptes en double, sinon votre demande sera annulée.',
            },
          ]
        },
        {
          title: 'Vérification des antécédents avec <img src="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/sterling.webp" alt=""> <span>Sterling</span>',
          list: [
            {
              text: 'Sterling effectue nos vérifications des antécédents. Surveillez votre boîte de réception pour un courriel de sa part – il pourrait accidentellement se glisser dans vos pourriels.',
            },
            {                     
              text: 'Fournissez l’historique de vos adresses des 5 dernières années; si vous habitez à la même adresse depuis plus de 5 ans, vous devrez peut-être l’entrer 2 fois.',
            },
            {
              text: "Si vous fournissez votre propre vérification des antécédents, assurez-vous qu’elle est datée des 90 derniers jours."
            }
          ],                                                      
        }
      ],
      buttonText: 'Inscrivez-vous',
      buttonURL: 'https://couriers.skipthedishes.com/signup'
    },
    diaries: {
      title: 'Les visages de Skip',
      videos: [
        {
          id: 'https://www.youtube.com/embed/4hCnhCMCA-I?si=5M2xE57tudiTTdLG',
        },
      ]
    },
    commonVideos: {
      title: 'Questions fréquentes',
      videos: [
        {
          title: 'De quels documents ai-je besoin?',
          image: 'courier-happy.webp',
          id: 'XH5Ov3u369k',
        },
        {
          title: 'Dois-je réserver mes parcours?',
          image: 'courier-bike.webp',
          id: 'jw9_wLQkXj8',
        },
        {
          title: 'La livraison, c’est flexible?',
          image: 'courier-group.webp',
          id: '9tcysPUoY58',
        },
        {
          title: 'Vérification des antécédents',
          image: 'courier-documents.webp',
          id: 'sS4eVCg7rkw',
        }
      ],
      terms: 'Ce contenu a été créé avec des actrices et acteurs professionnels qui ont été rémunérés pour leur participation.',
    },
    faqs: {
      title: 'D’autres questions?',
      questionsLeft: [
        {
          question: 'Quelles sont les exigences pour livrer avec Skip?',
          answer: `
          <p>Voici ce qu’il faut pour livrer avec nous :</p>
                <ul>
                  <li>Avoir 18 ans ou plus.</li>
                  <li>Un téléphone intelligent Apple ou Android avec un forfait de données.</li>
                  <li>Un vélo ou un véhicule assuré.</li>
                  <li>Un compte bancaire pour recevoir votre argent.</li>
                </ul>
                <p>Lors de l’inscription, nous pouvons également vous demander ce qui suit :</p>
                <ul>
                  <li>Une copie de votre passeport.</li>
                  <li>Une preuve d’autorisation de travail : certificat de naissance, passeport, certificat de statut d’Indien, permis de travail ou d’études.</li>
                </ul>
                <p>Vous aurez également besoin d’un sac isotherme, mais ne vous inquiétez pas, nous pouvons vous aider à vous en procurer un.</p>
                <p>N’oubliez pas que vous choisissez quand et à quelle fréquence vous livrez – c’est vous qui décidez. C’est parti!</p>
          `
        },
        {
          question: 'Comment serai-je payé?',
          answer: `
          <p>Avec Skip, vous gagnerez de l’argent pour chaque livraison. L’appli Coursier·ère vous enverra des « offres » de livraison que vous pourrez examiner et ensuite décider si vous souhaitez effectuer la livraison.</p>
          <p>Le montant offert pour chaque offre varie; les détails seront affichés dans l’appli avant que vous acceptiez l’offre.</p>
          <p>Nous versons l’argent que vous avez gagné directement dans le compte bancaire de votre choix chaque semaine.</p>`
        },
        {
          question: 'Dois-je soumettre mes disponibilités chaque semaine?',
          answer: `
          <p>Nous fonctionnons principalement en réseau fermé afin de maintenir un équilibre entre le nombre de coursières et coursiers disponibles et le volume de commandes prévu. Ainsi, nous pouvons éviter les situations où un trop grand nombre de coursières et coursiers sont en ligne pour une quantité de commandes insuffisantes. C’est notre façon de garder tout le monde occupé et heureux.</p>
          <p>Il est facile de soumettre vos disponibilités. Cliquez <a href="http://couriers.skipthedishes.com/linking/Availability" target="_blank">ici</a> pour accéder directement à la page de planification de l’horaire dans l’appli. Vous n’avez qu’à indiquer quand vous voulez livrer avant minuit tous les mercredis. Le lendemain, nous enverrons votre horaire par courriel et mettrons à jour la page <a href="http://couriers.skipthedishes.com/linking/MyShifts" target="_blank">Mon horaire</a> dans l’appli.</p>
          <p>Lorsque le volume de commandes est élevé, vous pourriez avoir l’occasion de livrer spontanément en accédant à l’appli sans avoir de parcours planifié, ce que nous appelons les « parcours ouverts ». La disponibilité des parcours ouverts n’est pas garantie. Nous vous recommandons donc de soumettre vos disponibilités chaque semaine.</p>`
        }
      ],
      questionsRight: [
        {
          question: 'Puis-je utiliser mon propre équipement?',
          answer: `
          <p>Il n’y a aucune obligation d’utiliser de l’équipement de marque Skip. N’hésitez pas à utiliser votre propre équipement, cependant, vous devez vous assurer qu’il répond à nos exigences minimales en matière de sécurité.</p>
          <p>Si vous avez vos propres sacs de livraison de qualité commerciale, vous pourrez nous communiquer les détails pendant le processus d’inscription pour que nous les approuvions.</p>`
        },
        {
          question: 'Ma zone de livraison de préférence est fermée, alors je me suis inscrit·e dans une autre zone. Puis-je changer ma zone de préférence?',
          answer: `<p>Veuillez vous inscrire seulement pour la zone dans laquelle vous souhaitez livrer. Si votre zone de préférence est fermée, nous ne serons pas en mesure de transférer votre compte.</p>`
        },
        {
          question: 'Comment fonctionne le paiement instantané?',
          answer: `
          <p>Le Dépôt éclair vous permet de retirer vos revenus de livraison instantanément vers une carte de débit acceptée, contre des frais de 1,99 $. Vous pouvez retirer vos revenus aussi souvent que vous le voulez, y compris les fins de semaine et les jours fériés. Les Dépôts éclair sont habituellement inscrits à votre compte dans les 30 minutes, selon le délai de traitement de votre établissement financier. </p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_skip.svg',
      link: 'https://www.skipthedishes.com/fr',
      buttonText: 'Inscrivez-vous',
      buttonURL: 'https://couriers.skipthedishes.com/signup',
    },
    gtm: {
      trackingID: 'GTM-PRGNM82',
      countryPlatform: 'ca',
      platform_language: 'fr'
    },
    canonical: {
      lang: 'fr',
      canonical: 'https://couriers.skipthedishes.com/application/fr',
      alt: [
        {
          lang: 'fr-ca',
          url: 'https://couriers.skipthedishes.com/application/fr'
        },
        {
          lang: 'en-ca',
          url: 'https://couriers.skipthedishes.com/application',
        },
      ]
    }
  },
  // AUS Independent Contractor
  at_en: {
    navbar: {
      logo: 'logo_menulog.svg',
      link: 'https://www.menulog.com.au/',
      language: 'Language',
      name: 'Menulog',
      country_toggle: [
        {
          logo: 'au',
          url: 'https://couriers.menulog.com.au/application',
          text: 'Australia'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application',
          text: 'Canada'
        },
        {
          logo: 'ca',
          url: 'https://couriers.skipthedishes.com/application/fr',
          text: 'Canada - FR'
        },
        {
          logo: 'ie',
          url: 'https://couriers.just-eat.ie/application',
          text: 'Ireland'
        },
        {
          logo: 'gb',
          url: 'https://couriers.just-eat.co.uk/application',
          text: 'Great Britain'
        },
      ],
      menu: [
        {
          text: 'Home',
          url: 'https://couriers.menulog.com.au/application',
          target: '_self'
        },
        {
          text: 'FAQs',
          url: 'https://couriers.menulog.com.au/application#faqs',
          target: '_self'
        },
        {
          text: 'The Inside Track',
          url: 'https://insidetrack.menulog.com.au',
          target: '_blank',
        },
      ],
      menuButton: {
        text: 'Apply now',
        url: 'https://couriers.menulog.com.au/signup'
,     },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Fast cash,<br>flexible work',
      sub: 'Make extra money fast and fit<br>delivering around your lifestyle.',
      buttonText: 'Apply now',
      buttonUrl: 'https://couriers.menulog.com.au/signup',
      image: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/Courier.webp'
    },
    benefits: {
      title: 'Why deliver with Menulog?',
      cards: [
        {
          name: 'Flexibility',
          color: 'red',
          image: 'flexible.webp',
          text: 'Freedom to deliver when you want. Choose your schedule and submit run requests each week.',
          hiddenMobile: false,
        },
        {
          name: 'Weekly pay',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'With weekly deposits direct to your bank account, you’ll get fast access to your cash.',
          hiddenMobile: true,
        },
        {
          name: 'Keep 100% of tips',
          color: 'purple',
          image: 'bag.svg',
          text: 'Earners, keepers. Whatever tips you make, you’ll pocket the full amount.',
          hiddenMobile: false,
        },
        {
          name: 'Be part of a community',
          color: 'pink',
          image: 'pins.svg',
          text: 'Join our community of couriers delivering throughout Austrailia.',
          hiddenMobile: false,
        },
        {
          name: 'Round-the-clock support',
          color: 'orange',
          image: 'support.svg',
          text: 'Whether you need advice or support, simply chat with us via the courier app.',
          hiddenMobile: false,
        },
        {
          name: 'No experience needed',
          color: 'blue',
          image: 'curior.svg',
          text: 'Making your first move? We welcome new starters with no previous experience.',
          hiddenMobile: true,
        },
      ]
    },
    requirements: {
      image: 'iPhone-AUS.webp',
      title: "What you'll need",
      list: [
        {
          text: 'Age 18+ ID',
        },
        {
          text: 'Smartphone - iOS or Android',
        },
        {
          text: 'An insured e-bike, scooter/motorbike or car',
        },
      ],
      tips: 'Tips to speed up your application',
      moreInfo: [
        {
          title: 'Grab these',
          list: [
            {
              text: 'Government-issued photo ID.'
            },
            {
              text: 'Details of your food delivery insurance.',
            },
            {
              text: 'ABN (Australian Business Number).'
            }
          ],
        },
        {
          title: 'Important',
          list: [
            {
              text: 'Please enter your full name on your courier application, as per your government ID. These details must match exactly.',
            },
            {
              text: 'Please don’t create duplicate accounts - doing so will result in your application being cancelled.',
            },
          ]
        },
        {
          title: `Background check with <img src="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/ncc-logo.svg" alt=""> <span>National Crime Check  </span>`,
          list: [
            {
              text: 'National Crime Check (NCC) run our background screening checks, look out for their email - this may accidentally end up in your spam folder.',
            },
            {
              text: "If you’re using your own background check, please make sure it's dated within the last 180 days."
            }
          ]
        }
      ],
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.menulog.com.au/signup'
    },
    diaries: {
      title: 'Menulog Meets',
      videos: [
        {
          id: 'https://www.youtube.com/embed/84CTietVBwI?si=IOB7ozUHucuPE9Us',
        },
      ]
    },
    commonVideos: {
      title: 'Common questions',
      videos: [
        {
          title: 'What documents do I need?',
          image: 'courier-happy.webp',
          id: 'EAcYoydFeIE',
        },
        {
          title: 'How flexible is delivering?',
          image: 'courier-bike.webp',
          id: 'mD_f-jqnPEc',
        },
        {
          title: 'How do I book delivery runs?',
          image: 'courier-group.webp',
          id: 'ylS_NXk_cOU',
        },
        {
          title: 'Completing your background check',
          image: 'courier-documents.webp',
          id: '7zChCcNeBSI',
        }
      ]
    },
    faqs: {
      title: 'More questions?',
      questionsLeft: [
        {
          question: 'What are the requirements to deliver with Menulog?',
          answer: `
          <p>To deliver with us, you’ll need:</p>
          <ul>
            <li>To be aged +18.</li>
            <li>An Apple or Android smartphone with data.</li>
            <li>An insured e-bike, scooter/motorbike or car - plus licence and the correct insurance.</li>
            <li>A bank account, so you can receive your money.</li>
          </ul>
          <p>When signing up, we may also ask for the following:</p>
          <ul>
            <li>A copy of your passport.</li>
            <li>Proof of your right to work.</li>
          </ul>
          <p>Drop it like it’s hot? You’ll also need a food delivery bag – but don’t worry, we can help you with that.</p>
          <p>Remember, you choose when, and how often, you deliver – the power is in your hands. Let's go!</p>
          `
        },
        {
          question: 'How do I make money?',
          answer: `
          <p>Delivering with Menulog means you’ll make money for each delivery. The courier app will send you delivery ‘offers,’ which you can then review and decide if you’d like to complete the delivery.</p>
                <p>The fee up for grabs for each offer varies and you’ll be shown details of this in app before accepting the offer.</p>
                <p>We pay the money you’ve made directly into your chosen bank account every week.</p>
                `
        },
        {
          question: 'Do I need to submit my availability every week?',
          answer: `
          <p>We mainly operate a closed network. This is to help make sure we maintain a balanced match between the number of available couriers and the anticipated volume of orders. This means we can try to avoid scenarios where an excess of couriers are online with insufficient orders to go around. It’s our way of trying to keep everybody busy and making money.</p>
          <p>Submitting your availability is easy via the scheduling section in the courier app. Simply submit when you’d like to deliver by midnight every Wednesday, and the following day, we’ll email your schedule as well as update the My Schedule page in app.</p>
<p>When things are busy, you might have the opportunity to spontaneously begin delivering by accessing the app without a booked run, referred to as “open runs.” The availability of open runs is not guaranteed so we recommend you submit your availability each week.</p>
                `
        }
      ],
      questionsRight: [
        {
          question: 'Can I use my own equipment?',
          answer: `
          <p>There's no obligation to use Menulog-branded equipment. Feel free to use your own equipment, however, you must ensure that it meets our minimum safety requirements.</p>
          <p>If you have your own commercial-grade food delivery bag(s), you’ll be able to share details with us for approval during the sign-up process.</p>`
        },
        {
          question: 'My preferred delivery zone is closed so I applied in a different one. Can I change to my preferred zone?',
          answer: `
          <p>Please only apply in the zone you wish to deliver in. If your preferred zone is closed, we’re not able to transfer your account.</p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_menulog.svg',
      link: 'https://www.menulog.com.au/',
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.menulog.com.au/signup',
    },
    gtm: {
      trackingID: 'GTM-PRGNM82',
      countryPlatform: 'au',
      platform_language: 'en'
    },
    canonical: {
      lang: 'en',
      canonical: 'https://couriers.menulog.com.au/application',
      alt: [
        {
          lang: 'en-au',
          url: 'https://couriers.menulog.com.au/application',
        },
      ]
    }
  },
  // AUS Employee
  pl_en: {
    navbar: {
      logo: 'logo_menulog.svg',
      link: 'https://www.menulog.com.au/',
      language: 'Language',
      name: 'Menulog',
      country_toggle: [
        {
          logo: 'au',
          url: '/',
          text: 'English'
        }
      ],
      menu: [
        {
          text: 'Home',
          url: 'https://couriers.menulog.com.au/employee',
          target: '_self'
        },
        {
          text: 'FAQs',
          url: 'https://couriers.menulog.com.au/employee#faqs',
          target: '_self'
        },
      ],
      menuButton: {
        text: 'Apply now',
        url: 'https://couriers.menulog.com.au/signup/employee'
,     },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Deliver as a Menulog Employee',
      sub: 'Menulog is proud to offer the first employed delivery courier positions in Australia. We’re now recruiting for part-time positions in Sydney.',
      buttonText: 'Apply now',
      buttonUrl: 'https://couriers.menulog.com.au/signup/employee',
      image: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/Courier.webp'
    },
    benefits: {
      title: 'What benefits do I get as an employed courier?',
      cards: [
        {
          name: 'Paid leave and superannuation',
          color: 'red',
          image: 'flexible.webp',
          text: 'Receive paid leave entitlements and superannuation payments on top of your salary (currently 11% of your salary).',
          hiddenMobile: false,
        },
        {
          name: 'Reliable schedule with hourly pay',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'Guaranteed, regular, reliable hours of work each week, with higher pay rates for evening, weekend and public holiday hours.',
          hiddenMobile: true,
        },
        {
          name: 'Referral bonus',
          color: 'purple',
          image: 'bag.svg',
          text: 'Employed couriers who refer a friend to this program get a $300 bonus when their friend passes their 6-month probation.',
          hiddenMobile: false,
        },
        {
          name: 'Dedicated support',
          color: 'orange',
          image: 'support.svg',
          text: 'Like any Menulog employee, you will have a manager as well as an online support team dedicated to supporting you with any day-to-day operational issues.',
          hiddenMobile: false,
        },
        {
          name: 'Paid training and free gear',
          color: 'blue',
          image: 'curior.svg',
          text: 'You’ll get paid for any additional courier training and education, plus we’ll send you free delivery and safety gear to use and keep.',
          hiddenMobile: true,
        },
      ]
    },
    faqs: {
      title: 'Have some questions? Read on!',
      questionsLeft: [
        {
          question: 'How do I earn money?',
          answer: `
          <p>As an employed courier you will be paid by the hour for every shift that you do. Each week, you will have regular, reliable shifts with a guaranteed number of hours.</p>
          <p>In these shifts, the advanced Menulog system will match your availability and location with available deliveries, to ensure an efficient use of your time.</p>
          <p>You will get paid on a weekly basis for all shifts. Your earnings will be reflected in your Payroll App (which will be explained at your Employed Courier Induction Training).</p>
          `
        },
        {
          question: 'What do I need to be an employed courier?',
          answer: `
          <p>You will need to be at least 18 years old, have your own mobile phone (Android 8+ phone or an iPhone iOS 12+) and access to a suitable bicycle, e-bike, scooter or motorcycle and provide copies of your Passport/Right to Work documentation (and motorcycle licence if applicable).</p>
          <p>While we will not provide your vehicle (bicycle, e-bike, scooter or motorcycle, we’ll compensate you for the wear and tear of using your own and for the cost of an inspection (see e-bike requirements below).</p>
          <p>Menulog will also provide you with all the specialised equipment you need in order to safely deliver on the network, including a thermal delivery bag and high-vis uniform.</p>
                `
        },
      ],
      questionsRight: [
        {
          question: 'What are the requirements for e-bikes?',
          answer: `
          <p>All e-bikes must comply with the Australian standard EN 15194 and you will need to have your e-bike inspected by Menulog transport partner Haa Haa. Menulog will cover the cost of this inspection.</p>
          <p>To comply with EN 15194:</p>
          <ul>
            <li>The motor must be electric</li>
            <li>The maximum continuous power output of the motor cannot exceed 250 watts measured at the wheel</li>
            <li>The rider must cycle to activate the motor</li>
            <li>The motor must cut-off once the vehicle reaches 25km/hr, or sooner if the rider stops pedalling</li>
            <li>The vehicle must be certified by the manufacturer and labelled as complying with EN 15194. The label must include the manufacturer’s name, the motor’s cut-off speed in km/hr and its continuous rated power in watts</li>
          </ul>
          <p>In addition to the e-bike standards, all bikes must:</p>
          <ul>
            <li>Be fitted with a working bell, horn or similar warning device</li>
            <li>Have at least one working brake</li>
            <li>Have a white light on the front of the bicycle and a red light and red reflector on the rear of the bike (Menulog can provide these lights and reflectors if required)</li>
          </ul>`
        },
        {
          question: 'When can I get started?',
          answer: `
          <p>Once you submit your application with all required documents, our team will get in touch within five business days. If you are successful and undergo the paid training, you will be able to start delivering within two weeks.</p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_menulog.svg',
      link: 'https://www.menulog.com.au/',
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.menulog.com.au/signup/employee',
    },
    gtm: {
      trackingID: 'GTM-PRGNM82',
      countryPlatform: 'au',
      platform_language: 'en'
    },
    canonical: {
      lang: 'en',
      canonical: 'https://couriers.menulog.com.au/employee',
      alt: [
        {
          lang: 'en-au',
          url: 'https://couriers.menulog.com.au/employee',
        },
      ]
    }
  },
  // NZ - NO LONGER IN USE!
  de_en: {
    navbar: {
      logo: 'logo_menulog.svg',
      link: 'https://www.menulog.co.nz/',
      language: 'Language',
      name: 'Menulog',
      country_toggle: [
        {
          logo: 'nz',
          url: 'https://couriers.menulog.co.nz/application',
          text: 'English'
        },
      ],
      menu: [
        {
          text: 'Home',
          url: 'https://couriers.menulog.co.nz/application',
          target: '_self'
        },
        {
          text: 'FAQs',
          url: 'https://couriers.menulog.co.nz/application#faqs',
          target: '_self'
        },
        {
          text: 'The Inside Track',
          url: 'https://insidetrack.menulog.co.nz',
          target: '_blank',
        },
      ],
      menuButton: {
        text: 'Apply now',
        url: 'https://couriers.menulog.co.nz/signup'
,     },
      announcementBanner: 'This is an announcement ticket for important notifications relating to courier’s work. The user can close it on Desktop.',
      announcementBannerActive: false, 
    },
    hero: {
      main: 'Fast cash,<br>flexible work',
      sub: 'Make extra money fast and fit<br>delivering around your lifestyle.',
      buttonText: 'Apply now',
      buttonUrl: 'https://couriers.menulog.co.nz/signup',
      image: 'Courier.png'
    },
    benefits: {
      title: 'Why deliver with Menulog?',
      cards: [
        {
          name: 'Flexibility',
          color: 'red',
          image: 'flexible.png',
          text: 'Freedom to deliver when you want. Choose your schedule and submit run requests each week.',
          hiddenMobile: false,
        },
        {
          name: 'Weekly pay',
          color: 'yellow',
          image: 'hour-glass.svg',
          text: 'With weekly deposits direct to your bank account, you’ll get fast access to your cash.',
          hiddenMobile: true,
        },
        {
          name: 'Keep 100% of tips',
          color: 'purple',
          image: 'bag.svg',
          text: 'Earners, keepers. Whatever tips you make, you’ll pocket the full amount.',
          hiddenMobile: false,
        },
        {
          name: 'Be part of a community',
          color: 'pink',
          image: 'pins.svg',
          text: 'Join our community of couriers delivering throughout New Zealand.',
          hiddenMobile: false,
        },
        {
          name: 'Round-the-clock support',
          color: 'orange',
          image: 'support.svg',
          text: 'Whether you need advice or support, simply chat with us via the courier app.',
          hiddenMobile: false,
        },
        {
          name: 'No experience needed',
          color: 'blue',
          image: 'curior.svg',
          text: 'Making your first move? We welcome new starters with no previous experience.',
          hiddenMobile: true,
        },
      ]
    },
    requirements: {
      image: 'iPhone-AUS.png',
      title: "What you'll need",
      list: [
        {
          text: 'Age 18+ ID',
        },
        {
          text: 'Smartphone - iOS or Android',
        },
        {
          text: 'An insured e-bike, scooter/motorbike or car',
        },
      ],
      tips: 'Tips to speed up your application',
      moreInfo: [
        {
          title: 'Grab these',
          list: [
            {
              text: 'Government-issued photo ID.'
            },
            {
              text: 'Details of your food delivery insurance.',
            },
            {
              text: 'NZBN (New Zealand Business Number).'
            }
          ],
        },
        {
          title: 'Important',
          list: [
            {
              text: 'Please enter your full name on your courier application, as per your government ID. These details must match exactly.',
            },
            {
              text: 'Please don’t create duplicate accounts - doing so will result in your application being cancelled.',
            },
          ]
        },
        {
          title: 'Background check with <img src="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/ncc-logo.svg" alt=""> <span>National Crime Check  </span>',
          list: [
            {
              text: 'National Crime Check (NCC) run our background screening checks, look out for their email - this may accidentally end up in your spam folder.',
            },
            {
              text: "If you’re using your own background check, please make sure it's dated within the last 180 days."
            }
          ]
        }
      ],
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.menulog.co.nz/signup'
    },
    diaries: {
      title: 'Menulog Meets',
      videos: [
        {
          id: 'https://www.youtube.com/embed/cb-K_knB_aQ?si=CiBEpgezW5h9xaSF',
        },
      ]
    },
    commonVideos: {
      title: 'Common questions',
      videos: [
        {
          title: 'What documents do I need?',
          image: 'courier-happy.png',
          id: 'EAcYoydFeIE',
        },
        {
          title: 'How flexible is delivering?',
          image: 'courier-bike.png',
          id: 'mD_f-jqnPEc',
        },
        {
          title: 'How do I book delivery runs?',
          image: 'courier-group.png',
          id: 'ylS_NXk_cOU',
        },
        {
          title: 'Completing your background check',
          image: 'courier-documents.jpg',
          id: '7zChCcNeBSI',
        }
      ]
    },
    faqs: {
      title: 'More questions?',
      questionsLeft: [
        {
          question: 'What are the requirements to deliver with Menulog?',
          answer: `
          <p>To deliver with us, you’ll need:</p>
          <ul>
            <li>To be aged +18.</li>
            <li>An Apple or Android smartphone with data.</li>
            <li>An insured e-bike, scooter/motorbike or car.</li>
            <li>A bank account, so you can receive your money.</li>
          </ul>
          <p>When signing up, we may also ask for the following:</p>
          <ul>
            <li>A copy of your passport.</li>
            <li>POWE (Proof of Work Eligibility). We accept Birth Certificates, Passports, Certificate of Indian Status, or your Work or Study permit</li>
          </ul>
          <p>Drop it like it’s hot? You’ll also need a food delivery bag – but don’t worry, we can help you with that.</p>
          <p>Remember, you choose when, and how often, you deliver – the power is in your hands. Let's go!</p>
          `
        },
        {
          question: 'How do I make money?',
          answer: `
          <p>Delivering with Menulog means you’ll make money for each delivery. The courier app will send you delivery ‘offers,’ which you can then review and decide if you’d like to complete the delivery.</p>
                <p>The fee up for grabs for each offer varies and you’ll be shown details of this in app before accepting the offer.</p>
                <p>We pay the money you’ve made directly into your chosen bank account every week.</p>
                `
        },
        {
          question: 'Do I need to submit my availability every week?',
          answer: `
          <p>We mainly operate a closed network. This is to help make sure we maintain a balanced match between the number of available couriers and the anticipated volume of orders. This means we can try to avoid scenarios where an excess of couriers are online with insufficient orders to go around. It’s our way of trying to keep everybody busy and making money.</p>
          <p>Submitting your availability is easy via the scheduling section in the courier app. Simply submit when you’d like to deliver by midnight every Wednesday, and the following day, we’ll email your schedule as well as update the My Schedule page in app.</p>
<p>When things are busy, you might have the opportunity to spontaneously begin delivering by accessing the app without a booked run, referred to as “open runs.” The availability of open runs is not guaranteed so we recommend you submit your availability each week.</p>
                `
        }
      ],
      questionsRight: [
        {
          question: 'Can I use my own equipment?',
          answer: `
          <p>There's no obligation to use Menulog-branded equipment. Feel free to use your own equipment, however, you must ensure that it meets our minimum safety requirements.</p>
          <p>If you have your own commercial-grade food delivery bag(s), you’ll be able to share details with us for approval during the sign-up process.</p>`
        },
        {
          question: 'My preferred delivery zone is closed so I applied in a different one. Can I change to my preferred zone?',
          answer: `
          <p>Please only apply in the zone you wish to deliver in. If your preferred zone is closed, we’re not able to transfer your account.</p>
          `
        }
      ]
    },
    footer: {
      logo: 'logo_menulog.svg',
      link: 'https://www.menulog.co.nz/',
      buttonText: 'Apply now',
      buttonURL: 'https://couriers.menulog.co.nz/signup',
    },
    gtm: {
      trackingID: 'GTM-PRGNM82',
      countryPlatform: 'nz',
      platform_language: 'en'
    },
    canonical: {
      canonical: 'https://couriers.menulog.co.nz/application',
      alt: [
        {
          lang: 'NZ',
          url: 'https://couriers.menulog.co.nz/application',
        },
      ]
    }
  },
};
